// extracted by mini-css-extract-plugin
export default {"list":"topics-list_list__Uk76h"};